export enum CctvStatusEnum {
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
    LOADING = 'LOADING',
}
